import { render } from "./Top45Of2025.vue?vue&type=template&id=0c9a41dc"
import script from "./Top45Of2025.vue?vue&type=script&lang=js"
export * from "./Top45Of2025.vue?vue&type=script&lang=js"

import "./Top45Of2025.vue?vue&type=style&index=0&id=0c9a41dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__